import * as C from '../styled';

import { FilterItem } from '../FilterItem';

import { getConditions, getOperator, isGroup } from '../utils';

export default {
    name: 'FilterGroup',
    props: {
        condition: {
            type: Object,
            required: true,
        },
        depth: {
            type: Number,
            required: true,
        },
        groupId: {
            type: String,
            default: undefined,
        },
    },
    render() {
        const { condition, depth, groupId } = this;

        const conditions = getConditions(condition);
        const operator = getOperator(condition);

        return (
            <C.Group depth={depth}>
                {conditions.map((condition, idx) => {
                    const isGroupCondition = isGroup(condition);

                    return (
                        <C.GroupRow key={idx}>
                            {idx !== 0 && (
                                <C.GroupOperator>{operator}</C.GroupOperator>
                            )}
                            {isGroupCondition ? (
                                <FilterGroup
                                    condition={condition}
                                    depth={depth + 1}
                                    groupId={groupId}
                                />
                            ) : (
                                <FilterItem
                                    condition={condition}
                                    groupId={groupId}
                                />
                            )}
                        </C.GroupRow>
                    );
                })}
            </C.Group>
        );
    },
};
